import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { BsList } from 'react-icons/bs';

import logoWhiteSrc from '../../asset/images/global/logo_white.png';
import logoBlackSrc from '../../asset/images/global/logo_black.png';
import MobileGnb from '../MobileGnb';

import { ITEM_PAGE_ARR } from './constants';
import { getPageH1Title } from './util';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Header = () => {
  const [scrollY, setScrollY] = useState(window.scrollY);
  const [isScrollUp, setIsScrollUp] = useState(false);
  const [isMobileGnb, setIsMobileGnb] = useState(false);
  const { pathname } = useLocation();

  const handleNavigation = useCallback(
    (event) => {
      const window = event.currentTarget;
      if (scrollY > window.scrollY) {
        setIsScrollUp(true);
      } else if (scrollY < window.scrollY) {
        setIsScrollUp(false);
      }
      setScrollY(window.scrollY);
    },
    [scrollY],
  );

  useEffect(() => {
    window.addEventListener('scroll', handleNavigation);

    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  const logoSrcCreator = () => {
    for (const page of ITEM_PAGE_ARR) {
      if (page === pathname) {
        return logoBlackSrc;
      }
    }

    if (isScrollUp) {
      return logoBlackSrc;
    } else {
      return logoWhiteSrc;
    }
  };

  const setIsBlackColor = () => {
    for (const page of ITEM_PAGE_ARR) {
      if (page === pathname) {
        return 'black';
      }
    }
    return 'white';
  };

  const handleShowMobileGnb = () => {
    setIsMobileGnb(true);
  };
  return (
    <>
      <header className={cx(['header', isScrollUp && 'active'])}>
        <ul className={cx('gnb')}>
          <li className={cx([setIsBlackColor(), 'logo'])}>
            <h1
              onClick={() => {
                window.scrollTo(0, 0);
              }}>
              <Link to="/">
                <img src={logoSrcCreator()} alt={getPageH1Title(pathname)} />
              </Link>
            </h1>
          </li>
          <li className={cx(setIsBlackColor())}>
            <Link to="/about">ABOUT</Link>
          </li>
          <li className={cx(setIsBlackColor())}>
            <Link to="/product">PRODUCT</Link>
          </li>
          {/* <li className={cx(setIsBlackColor())}>
            <a href="https://smartstore.naver.com/levrai_cosmetic/category/d587c378d7514158bb7993d168403328?cp=1" target="_blank" rel="noreferrer">SHOP</a>
          </li> */}
          <li className={cx(setIsBlackColor())}>
            <Link to="/about#contact">CONTACT</Link>
          </li>
          <li className={cx([setIsBlackColor(), 'mobileButton'])}>
            <button type="button" onClick={handleShowMobileGnb}>
              <BsList />
            </button>
          </li>
        </ul>
      </header>
      {isMobileGnb && <MobileGnb setIsMobileGnb={setIsMobileGnb} />}
    </>
  );
};

export default Header;
